import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Construction } from "lucide-react";

interface PlaceholderPageProps {
  title: string;
}

export default function PlaceholderPage({ title }: PlaceholderPageProps) {
  return (
    <div className="container mx-auto px-4 py-16">
      <div className="flex flex-col items-center space-y-6">
        <Construction size={64} className="text-base-content" />
        <h1 className="text-4xl font-bold text-primary">{title}</h1>
        <p className="text-xl text-base-content/70 text-left">
          This feature is coming soon!
        </p>
        <Link to="/" className="btn btn-ghost text-base-content">
          <ArrowLeft size={20} />
          <span className="ml-2">Back to Home</span>
        </Link>
      </div>
    </div>
  );
}
